import React from 'react';

import ListPagePaginated from '@/src/shared/components/ListPage/ListPagePaginated';
import useListSearch from '@/src/shared/hooks/useListSearch';

const FederalBulletin = () => {
  const [loading, results, cacheKey] = useListSearch({
    pubCode: 433,
    yearsBack: 5,
  });

  return (
    <ListPagePaginated
      title="Federal Bulletin"
      heroContent={<p>Documents from the last 5 years</p>}
      results={results}
      truncateResultSummary
      loading={loading}
      cacheKey={cacheKey}
    />
  );
};

export default FederalBulletin;
